import React from "react"
import HeroContent from "./hero-content"
import ScrollAnimation from "react-animate-on-scroll"
import HeroImgDesktop from "./convenient-booking-img-desktop"
import HeroImgMobile from "./convenient-booking-img-mobile"
import ConvenientBookingPageStyle from "./convenient-booking-page.module.scss"

const Hero = () => (
    <div className={ConvenientBookingPageStyle.heroDiv}>
        <ScrollAnimation className="fadeIn" animateOnce={true} duration={2}>
            <HeroImgDesktop className={ConvenientBookingPageStyle.heroImgDesktop} />
            <HeroImgMobile className={ConvenientBookingPageStyle.heroImgMobile} />
        </ScrollAnimation>
        <HeroContent />
    </div>
)

export default Hero